import React from 'react';

import CatalogoTiposSeguimiento from './CatalogoTiposSeguimiento';
import { getTipoSeguimientoSeg, tablaTipoSeguimientoSeg } from '../../../querys/TiposSeguimiento';
import { addTipoSeguimientoSeg, updateTipoSeguimientoSeg, deleteTipoSeguimientoSeg } from '../../../mutations/TiposSeguimiento';

function TiposSeguimientoSeguros() {
    return <CatalogoTiposSeguimiento
        titulo="Tipos de Seguimiento Seguros"
        asyncGet={getTipoSeguimientoSeg}
        asyncTabla={tablaTipoSeguimientoSeg}
        asyncAdd={addTipoSeguimientoSeg}
        asyncUpdate={updateTipoSeguimientoSeg}
        asyncDelete={deleteTipoSeguimientoSeg}
    />;
}

export default TiposSeguimientoSeguros;
